import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { environment } from '../environments/environment';



@Injectable()
export class CoreService {
    private baseHeader = new HttpHeaders();
    private rootApiUrl = environment.apiUrl;
    constructor(private http: HttpClient) {
        this.baseHeader = this.baseHeader.set('Cache-Control', 'no-cache');
        this.baseHeader = this.baseHeader.set('Pragma', 'no-cache');
        this.baseHeader = this.baseHeader.set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
    }

    get(relativeUrl: string): Observable<any> {
        // var token = sessionStorage.getItem('currentUser'));
        // let headers = this.baseHeader.set( 'Authorization', 'Bearer ' + token.token );

        const resp = this.http.get(this.rootApiUrl + relativeUrl, {
            headers: this.baseHeader
        });
        return resp;
    }

    post(relativeUrl: string, body: Object): Observable<any> {
        const headers = this.baseHeader.set('Content-Type', 'application/json');
        const resp = this.http.post(this.rootApiUrl + relativeUrl, body, {
            headers: headers
        });
        return resp;
    }



}
